import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Artifact } from '../artifact.js';
import { linkStyles } from './cssstyles.js';

@customElement('trace-attachment')
class TraceAttachment extends LitElement {
  @property({ attribute: false }) artifact?: Artifact;

  override render() {
    const artifact = this.artifact;
    if (!artifact)
      return nothing;
    return html`
      <v-box class=wrapper>
        <a class=thumbnail-link href=${artifact.viewerUrl ?? artifact.url} target=_blank rel="noopener noreferrer">
          <img class="thumbnail dropshadow" src='/playwright-trace.png'>
        </a>
        <h-box class=caption>
          <span class=filename>${artifact.fileName}</span>
          <a class=download href=${artifact.url} download=${artifact.fileName}>
            <sl-icon name=download></sl-icon>
          </a>
        </h-box>
      </v-box>
    `;
  }

  static styles = [linkStyles, css`
    :host {
      display: block;
    }

    .wrapper {
      gap: var(--sl-spacing-x-small);
      align-items: center;
    }

    .thumbnail-link {
      display: inline-flex;
    }

    .thumbnail {
      width: var(--trace-attachment-thumb-width, 200px);
      cursor: pointer;
      border-radius: var(--sl-border-radius-large);
    }

    .dropshadow {
      box-shadow: 0 0 4px 0px var(--sl-color-neutral-400);
    }

    .caption {
      gap: var(--sl-spacing-2x-small);
      align-items: center;
      font-size: var(--sl-font-size-small);
    }

    .filename {
      font-family: var(--sl-font-mono);
    }

    .download {
      display: inline-flex;
      align-items: center;
      color: var(--sl-color-neutral-600);
    }

    .download:hover {
      color: var(--sl-color-primary-600);
    }
  `];
}
